module.exports = __webpack_public_path__ + "img/167.1ec6a0a8.jpg";